import VenteeApp from ".";
const Routes = [
    {
        path: "/",
        component: VenteeApp,
    },
];

export default Routes;
